import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'success', duration = 2000) => {
    setNotification({ message, type, duration });
  }, []);

  const notifySuccess = (msg, duration) => showNotification(msg, 'success', duration);
  const notifyError = (msg, duration) => showNotification(msg, 'error', duration);
  const notifyInfo = (msg, duration) => showNotification(msg, 'info', duration);

  const clearNotification = () => setNotification(null);

  return (
    <NotificationContext.Provider value={{
      notification,
      notifySuccess,
      notifyError,
      notifyInfo,
      clearNotification
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext); 